import React, { useState } from 'react';

function StoryEditor({ addStory }) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setPreview(null);
    }
  };

  const handlePublish = async () => {
    if (isUploading) return; // prevent double-clicks
    if (!title && !imageFile) {
      alert('Please provide a title or an image.');
      return;
    }

    setIsUploading(true);
    const formData = new FormData();
    formData.append('title', title);
    formData.append('content', content);
    if (imageFile) formData.append('image', imageFile);

    try {
      // POST multipart/form-data
      const res = await fetch('https://storypublisher.onrender.com/stories', {
        method: 'POST',
        body: formData
      });

      if (!res.ok) {
        const err = await res.text();
        throw new Error(err || 'Upload failed');
      }

      const saved = await res.json();
      addStory(saved);
      setTitle('');
      setContent('');
      setImageFile(null);
      setPreview(null);
    } catch (err) {
      console.error('Publish error:', err);
      alert('Failed to publish. Try again.');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="editor">
      <h2>Post Something New</h2>
      <input 
        type="text" 
        placeholder="Story Title" 
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <textarea 
        placeholder="Start writing here..."
        value={content}
        onChange={(e) => setContent(e.target.value)}
      />

      <div>
        <label htmlFor="image-input">Add an image (optional):</label>
        <input id="image-input" type="file" accept="image/*" onChange={handleImageChange} />
      </div>

      {preview && (
        <div>
          <p>Preview:</p>
          <img src={preview} alt="preview" style={{ maxWidth: '300px' }} />
        </div>
      )}

      <button onClick={handlePublish} disabled={isUploading}>
        {isUploading ? 'Publishing...' : 'Publish'}
      </button>
    </div>
  );
}

export default StoryEditor;
